// src/frontend/modules/slot-event-listeners.js
import { EVENT_TYPES } from '../../shared/settings';
import { runTrackingEvents, addGoogleEventListener } from './reporting-tool';

/**
 * Sets up the slotRequested event listener
 */
export const slotRequestedListener = () => {
  addGoogleEventListener(EVENT_TYPES.SLOT_REQUESTED, (event) => {
    runTrackingEvents({
      eventType: EVENT_TYPES.SLOT_REQUESTED,
      slotId: event?.slot?.getSlotElementId(),
      additionalData: {
        slot_is_empty: true,
        creative_size: null,
      },
    });
  });
};

/**
 * Sets up the slotRenderEnded event listener
 */
export const slotRenderEndedListener = () => {
  addGoogleEventListener(EVENT_TYPES.SLOT_RENDER_ENDED, (event) => {
    const slotId = event?.slot?.getSlotElementId();

    if (slotId && slotId.trim() !== '') {
      runTrackingEvents({
        eventType: EVENT_TYPES.SLOT_RENDER_ENDED,
        slotId,
        additionalData: {
          slot_is_empty: event?.isEmpty,
          creative_size: event?.size ? `${event?.size[0]}x${event?.size[1]}` : null,
          advertiser_id: event?.advertiserId,
          campaign_id: event?.campaignId,
          creative_id: event?.creativeId,
        },
      });
    }
  });
};

/**
 * Sets up the impressionViewable event listener
 */
export const impressionViewableListener = () => {
  addGoogleEventListener(EVENT_TYPES.IMPRESSION_VIEWABLE, (event) => {
    const slotResponseInfo = event?.slot?.getResponseInformation();

    runTrackingEvents({
      eventType: EVENT_TYPES.IMPRESSION_VIEWABLE,
      slotId: event?.slot?.getSlotElementId(),
      additionalData: {
        slot_is_empty: false,
        creative_size: null,
        advertiser_id: slotResponseInfo?.advertiserId,
        campaign_id: slotResponseInfo?.campaignId,
        creative_id: slotResponseInfo?.creativeId,
      },
    });
  });
};
